import {TimeSheetItemStatus, TimeSheetItemType} from '../../../features/schedule/types';
import {TimeReportItem} from '../../../features/time-report/types';
import {TimeReportV2DailyItem, TimeReportV2Item} from '../../../features/time-report-v2/types';

const normalizeDate = (value: string): string => value.split('T')[0] ?? value;

export const mapTimeReportV2Item = (item: TimeReportV2Item): TimeReportItem => {
    const projectId = item.isAbsence ? item.absenceId ?? 0 : item.projectId ?? 0;

    return {
        id: item.employeeId,
        date: '',
        employeeName: item.employeeName,
        typeName: item.isAbsence ? item.absenceName ?? '' : '',
        comment: '',
        projectId,
        projectName: item.isAbsence ? item.absenceName ?? '' : item.projectName ?? '',
        clientId: 0,
        clientName: item.clientName ?? '',
        status: TimeSheetItemStatus.NORMAL,
        timeshiftTypeId: projectId,
        timeshiftType: item.isAbsence ? TimeSheetItemType.ABSENCE : TimeSheetItemType.SHIFT,
        isOvertime: item.overtime > 0,
        workHours: item.isAbsence ? 0 : item.hours,
        approvedHours: item.approved,
        billedHours: item.billed,
        isBillable: item.billed > 0,
        absenceHours: item.isAbsence ? item.hours : 0,
        plannedHours: item.plannedHours,
        overtimes: item.overtime,
        timeBankHours: item.timeBankHours !== 0 ? item.timeBankHours : undefined,
        absenceBehavior: item.absenceBehavior,
    };
};

export const mapTimeReportV2DailyItem = (item: TimeReportV2DailyItem): TimeReportItem => {
    const projectId = item.isAbsence ? item.absenceId ?? 0 : item.projectId ?? 0;

    return {
        id: item.employeeId,
        date: normalizeDate(item.date),
        employeeName: item.employeeName,
        typeName: item.isAbsence ? item.absenceName ?? '' : item.shiftType ?? '',
        comment: item.comment ?? '',
        projectId,
        projectName: item.isAbsence ? item.absenceName ?? '' : item.projectName ?? '',
        clientId: 0,
        clientName: '',
        status: TimeSheetItemStatus.NORMAL,
        timeshiftTypeId: projectId,
        timeshiftType: item.isAbsence ? TimeSheetItemType.ABSENCE : TimeSheetItemType.SHIFT,
        isOvertime: item.isOvertime,
        workHours: item.isAbsence ? 0 : item.shiftHours,
        approvedHours: item.approved,
        billedHours: item.billed,
        isBillable: item.billed > 0,
        absenceHours: item.isAbsence ? item.absenceHours : 0,
        plannedHours: item.plannedHours,
        overtimes: item.isOvertime ? item.shiftHours : 0,
        timeBankHours: item.timeBankHours !== 0 ? item.timeBankHours : undefined,
        absenceBehavior: item.absenceBehavior,
    };
};
